import { SELECTED_EMPLOYEE_ARROW_STYLE } from './selectedEmployeeArrowLayout';

import {
    PeerReviewToRevieweeFrIllustration,
    PeerReviewToRevieweeIllustration,
} from '@/components/Illustrations/Illustration';
import i18n from '@/plugins/i18n';

interface SelectedEmployeeArrowProps {
    dataTestId?: string;
}

/**
 * The decorative arrow that joins the assessment card to the employee it is about, carrying the
 * FOR/POUR pill drawn into the artwork. It is drawn, never read: it says nothing the two cards
 * either side of it do not already say.
 *
 * Belongs inside the selected-employee card's positioned wrapper, which is what it is placed
 * against — see `selectedEmployeeArrowLayout.ts` for the geometry.
 */
export const SelectedEmployeeArrow = ({
    dataTestId = 'selected-employee-arrow',
}: SelectedEmployeeArrowProps) => {
    const Arrow = i18n.language.startsWith('fr')
        ? PeerReviewToRevieweeFrIllustration
        : PeerReviewToRevieweeIllustration;

    return (
        <div
            aria-hidden
            className={'pointer-events-none absolute z-10'}
            style={SELECTED_EMPLOYEE_ARROW_STYLE}
            data-testid={dataTestId}
        >
            <Arrow className={'h-full w-full opacity-80'} />
        </div>
    );
};
